import React from 'react';
import './spinning-loader.scss';

export function SpinningLoader() {
  return (
    <>
      <span className="spinning-loader"></span>
    </>
  );
}
